export default __webpack_public_path__ + "static/doctor-with-mobile-f8b6d809ae2228f4372a724569ba48e7.png";